interface RaceLiveCheck {
    isOfficial?: boolean | null;
    isByUtmb?: boolean | null;
    isAutoSyncAvailable?: boolean | null;
    status?: string | null;
    bettingDeadline?: string | null;
}

export function isRaceLive(race: RaceLiveCheck): boolean {
    return !!(
        race.isOfficial &&
        race.isByUtmb &&
        race.isAutoSyncAvailable &&
        race.status === 'OPEN' &&
        race.bettingDeadline &&
        new Date(race.bettingDeadline).getTime() < Date.now()
    );
}

export function isRacing(race: { status?: string | null; bettingDeadline?: string | null }): boolean {
    return !!(
        race.status === 'OPEN' &&
        race.bettingDeadline &&
        new Date(race.bettingDeadline).getTime() < Date.now()
    );
}
